
export default {
  props:{
    dialog:{
      type: Boolean,
      default:  function () {
        return false;
    }},
    onClose: {
      type: Function,
      required: true,
    },
    resultado: {
      type: Object
    }
  }

}
